import useLazyQuery from "../useLazyQuery"

export const useOpenDoorQuery = (doorId: string) => {
	const url = `${process.env.REACT_APP_ACCESS_CONTROL_BACK_URL}/doors/${doorId}/open`
	return useLazyQuery<void, void>(url, "POST")
}
